export * from './actions';
export * from './effects';
export * from './service';

export { featureKey as postUserKey, initialState as postUserInitialState, State as PostUserState } from './reducer';

export {
  getData as postUserGetData,
  getError as postUserGetError,
  getLoading as postUserGetLoading,
  mapData as postUserMapData,
} from './selectors';
